<template>
  <div style="height:100%; width:100%; text-align:center">
    <v-progress-circular
      :size="80"
      color="primary"
      indeterminate
      v-show="loading"
      style="margin-top:20px;"
    ></v-progress-circular>
    <iframe
      v-show="!loading"
      :src="url"
      frameborder="0"
      width="100%"
      height="100%"
      allowtransparency
    ></iframe>
  </div>
</template>

<script>
  export default {
    props: {
      report: Object,
      reportService: Object
    },
    data () {
      return {
        loading: false,
        url: null
      }
    },

    created () {
      this.load()
    },

    watch: {
      report (report) {
        if (report) {
          this.load()
        }
      }
    },

    methods: {
      load () {
        this.loading = true
        this.url = null
        this.reportService
          .get(this.report.report)
          .then(({ data }) => {
            this.url = data.data
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/Common/Report/Report.vue